import React from 'react';
import Title from '../../../elements/Title';
import Link from '../../../components/Link';
import Content from '../../../elements/Content';
import Section from '../../../elements/Section';
import { classes, LINKS } from './utils';

export default function GeneralShareholdersMeeting() {
  return (
    <Section>
      <Title>General Shareholders' Meeting</Title>
      <Content className={classes.content}>
        The Annual General Shareholders' Meeting of the Company takes place the
        first Tuesday of the month of June at 7:00PM (CET), or the next
        following workday it this Tuesday is on a public holiday.
      </Content>
      <Content className={classes.content}>
        The next Annual General Shareholders' Meeting of the Company will take
        place in <span className={classes.meetingDate}>June 2024</span>. You can
        download the Notice letter (in Dutch) of this Annual General
        Shareholders Meeting{' '}
        <Link href={LINKS.meetingLink} target="_blank">
          here
        </Link>
        .
      </Content>
      <Content className={classes.content}>
        Security holders who wish to participate in a general meeting or wish to
        be represented by a proxy are requested to comply with the statutes of
        the Company as mentioned in the notice letter.
      </Content>
      <Content className={classes.content}>
        If you, as a security holder, wish to be represented by a proxyholder,
        please use the proxy document drawn up by the board of directors of the
        Company. This proxy document can be received at the registered office of
        the Company or by sending an email to{' '}
        <Link href="mailto:investors@condorflash.com">
          investors@condorflash.com
        </Link>
        .
      </Content>
      <Content className={classes.content}>
        The documents that under the Belgian Company Code need to be made
        available to the security holders can be obtained freely in Dutch at the
        registered office of the Company, at least fifteen (15) days prior to
        each general meeting (article 7:132 of the Belgian Companies and
        Associations Code).
      </Content>
    </Section>
  );
}
